<template>
  <basic-dialog
    class="goods-sel-dlg"
    :title="title"
    width="80%"
    :visible="visible"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
    :isShowFooterAll="true"
    :showFt="action !== 'view'"
    :okText="okText"
    :closeText="closeText"
  >
    <el-form
      ref="form1"
      class="search-form"
      size="small"
      label-width="100px"
      :model="dto"
      :rules="rules"
    >
      <div class="entity-dlg__block-bd">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('language.5o6uj7uysto0')" prop="roleName">
              <el-input
                v-model.trim="dto.roleName"
                clearable
                :disabled="action === 'view'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('language.5o6uj7uysxs0')" prop="roleCode">
              <el-input
                v-model.trim="dto.roleCode"
                :placeholder="$t('language.5o6vg67fnms0')"
                clearable
                :disabled="action !== 'add'"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              v-if="this.showFlowID"
              label="是否可申请"
              prop="isApply"
              :rules="[
                {
                  required: true,
                  message: '是否可申请不能为空',
                  trigger: 'blur',
                },
              ]"
            >
              <el-select v-model="dto.isApply">
                <el-option label="是" :value="0" />
                <el-option label="否" :value="1" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item v-if="this.showFlowID">
              <div slot="label">
                {{$t('language.5o6vg67fmbw0')}}
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    {{$t('language.5o6vg67fmes0')}}
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              <el-input v-model.trim="dto.illustration" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('language.5o6otz4p1w00')" prop="remark">
              <el-input
                v-model="dto.remark"
                clearable
                :disabled="action === 'view'"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="col-r"></div>
    </el-form>
    <el-form
      class="search-form"
      size="small"
      label-width="100px"
      :model="query"
    >
      <div class="col-l">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('language.5o6umf8wpe40')">
              <el-select
                v-model="query.type"
                clearable
                value-key="id"
                @change="onChangeDataType"
                :placeholder="$t('language.5o6u3f3cnok0')"
              >
                <el-option
                  v-for="item in types"
                  :key="item.id"
                  :value="item"
                  :label="item.typeName"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8" v-for="item in activeFields" :key="item.id">
            <el-form-item :label="item.name">
              <!-- <el-input v-if="item.type === 'input'" v-model.trim="query[item.key]" clearable /> -->
              <el-autocomplete
                v-if="item.type === 'input'"
                v-model.trim="query[item.key]"
                :debounce="500"
                :fetch-suggestions="
                  (value, cb) => querySearchThink(value, cb, item.key)
                "
                :placeholder="`${$t('language.5o6umf8wq2o0')}` + item.name"
                :maxlength="30"
                clearable
              >
              </el-autocomplete>
              <el-select
                v-else-if="item.type === 'enums'"
                v-model.trim="query[item.key]"
                :placeholder="`${$t('language.5o6u3f3cnok0')}${item.name}`"
                clearable
                filterable
              >
                <el-option
                  v-for="subItem in item.enums"
                  :key="subItem.code"
                  :label="subItem.label"
                  :value="subItem.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="col-r">
        <el-button type="primary" size="small" @click="handleSearch"
          >{{$t('language.5o6trh9vn600')}}</el-button
        >
        <el-button size="small" @click="handleReset">{{$t('language.5o6trh9vn900')}}</el-button>
      </div>
    </el-form>
    <basic-list
      ref="basicList"
      select-type="multiple"
      :tableH="500"
      :show-select-col="list.length !== 0"
      :show-action-col="false"
      :show-index-col="false"
      :fields="fields"
      :setClmnsFlg="false"
      :list="list"
      :loading="loading"
      :total="total"
      :page-index="pageIndex"
      :page-size="pageSize"
      :page-index-change="pageIndexChange"
      :page-size-change="pageSizeChange"
      :selection-change="selectionChange"
      :useRowClick="action !== 'view'"
      :is-tab-disabel="action === 'view'"
    />
  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/basicDialog";
import BasicList from "@/components/basicList";

const DEFAULTS = {
  loading: false,
  total: 0,
  query: { type: undefined },
  pageIndex: 0,
  pageSize: 10,
  list: [],
  selRows: [],
  types: [],
  activeFields: [],
  rules: {
    roleName: [
      { required: true, message: window.__VM__.$t('language.5o6vg67fmm40'), trigger: "blur" },
      // {
      //   pattern: CNST.REG_EXP.NORMAL_ROLE,
      //   message: "角色名称不可输入特殊字符",
      // },
      { max: 80, message: window.__VM__.$t('language.5o6vg67fmog0') },
    ],
    roleCode: [
      { required: true, message: window.__VM__.$t('language.5o6vg67fneo0'), trigger: "blur" },
      {
        pattern: CNST.REG_EXP.NORMAL_ROLE,
        message: window.__VM__.$t('language.5o6vg67fnms0'),
        trigger: ["change", "blur"],
      },
      { max: 80, message: window.__VM__.$t('language.5o6vg67fnqk0') },
    ],
    remark: [
      { max: 120, message: window.__VM__.$t('language.5o6vg67fntc0') },
    ],
  },
};

export default {
  components: {
    BasicDialog,
    BasicList,
  },
  props: {
    showFlowID: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    updateVis: {
      type: Function,
      default: () => {},
    },
    handleSave: {
      type: Function,
      default: () => {},
    },
    action: {
      type: String,
      default: undefined,
    },
    entity: {
      type: Object,
    },
    tenementCode: {
      type: [Number, String, undefined],
      default: undefined,
    },
    title: {
      type: String,
      default: "",
    },
  },
  beforeCreate() {
    this.dtoFields = [
      "roleName",
      "roleCode",
      "remark",
      "isApply",
      "illustration",
    ];
  },
  created() {
    this.queryTypeList();
  },
  activated() {
    this.queryTypeList();
  },
  mounted() {
    console.log(this.dto, this.dto.isApply, "mounted");
  },
  data() {
    return {
      ..._.cloneDeep(DEFAULTS),
      dto: this.getDefaultDto(),
      // 展示字段
      fields: this.handleSetField(),
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.query = { ...DEFAULTS.query };
        this.pageIndex = 0;
        this.dto = _.pick(this.entity, [
          "roleName",
          "roleCode",
          "id",
          "remark",
          "isApply",
          "illustration",
        ]);
        if (this.dto.isApply === undefined) {
          this.dto.isApply = 0;
        } else {
        }
        this.queryList();
      }
    },
    action(newVal) {
      if (newVal === "add") {
        this.dto = this.getDefaultDto();
      }
    },
    "dto.isApply": {
      handler(val, oldVal) {
        console.log(val, oldVal, "watch");
      },
      deep: true,
    },
  },
  methods: {
    handleClose() {
      this.updateVis(false);
      // this.queryList()
    },
    handleClosed() {
      const defaults = _.cloneDeep(_.get(DEFAULTS, ["selRows", "query"]));
      for (let key in defaults) {
        this[key] = defaults[key];
      }
      this.$refs.basicList.resetData();
      this.activeFields.length = 0;
      this.list = [];
      this.fields = this.handleSetField();
    },
    handleOk() {
      this.$refs.form1.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          const params = this.toEnd();
          this.handleSave({ params, type: this.action });
        }
      });
    },
    pageIndexChange(index) {
      this.pageIndex = index - 1;
      this.queryList();
    },
    pageSizeChange(size) {
      this.pageIndex = 0;
      this.pageSize = size;
      this.queryList();
    },
    selectionChange(rows) {
      this.selRows = rows;
    },
    handleSearch() {
      this.pageIndex = DEFAULTS.pageIndex;
      this.queryList();
    },
    handleReset() {
      this.query = _.cloneDeep(DEFAULTS.query);
      this.pageIndex = DEFAULTS.pageIndex;
      this.activeFields.length = 0;
      this.fields = this.handleSetField();
      this.queryList();
    },
    queryList() {
      this.list.length = 0;
      let { id } = this.query.type || {};
      if (!id) return;
      const data = {
        typeId: id,
        tenementCode: this.tenementCode,
        dataRoleId: this.entity.id,
        ..._.omit(this.query, ["type"]),
      };
      jt.object.removeEmptyAttr(data);
      const params = {
        data,
        page: { pageIndex: this.pageIndex + 1, pageSize: this.pageSize },
      };
      // jt.object.removeEmptyAttr(query)
      // this.$refs.basicList.$refs.table.clearSelection(this.list)
      api.dataRole.queryDataResourceList(params).then(({ code, data }) => {
        if (code === 200) {
          this.list = data.rows || [];
          this.total = data.rowTotal || 0;
          // 设置默认选中状态
          this.$nextTick(() => {
            let arr = this.list.filter((item) => item.tenementId);
            arr.forEach((item) => {
              this.$refs.basicList.$refs.table.toggleRowSelection(item, true);
            });
          });
        }
      });
    },
    toEnd() {
      // 角色信息 this.dto 所选用户 this.selRows
      const dataResourceIds = [];
      this.selRows.forEach((item) => {
        dataResourceIds.push(item.id);
      });
      const allDataResourceIds = [];
      this.list.forEach((item) => {
        allDataResourceIds.push(item.id);
      });
      const paramsFix = {
        tenementCode: this.$store.state.app.tenementInfoObj.tenementCode,
        allDataResourceIds, // 当前页的数据资源id列表
        // 选中的数据资源id列表
        dataResourceIds,
      };
      jt.object.removeEmptyAttr(paramsFix);
      const params = { ...this.dto, ...paramsFix };
      if (this.action === "add") {
        delete params.id;
      }
      return params;
    },
    getDefaultDto() {
      const dto = {};
      this.dtoFields.forEach((item) => {
        dto[item] = undefined;
      });

      dto.isApply = 0;
      console.log(dto, dto.isApply, "hhh");
      return dto;
    },
    // 数据类型枚举
    queryTypeList() {
      const params = {
        data: { tenementCode: this.tenementCode },
        page: { pageIndex: 1, pageSize: 1000 },
      };
      api.dataRole.queryTypeList(params).then(({ code, data }) => {
        if (code === 200) {
          this.types = data.rows || [];
        }
      });
    },
    //  数据类型联动
    onChangeDataType(dataType) {
      this.list.length = 0;
      this.activeFields = this.handleSetField(dataType.dataExtInfoList);

      this.fields = this.activeFields.map((item) => {
        return _.pick(item, ["key", "name", "render"]);
      });
      let orgName = {
        key: "orgName",
        name: `${this.$t('language.5o6trh9vmuo0')}`,
      };
      let dataCode = {
        key: "dataCode",
        name: `${this.$t('language.5o6umf8wqfc0')}`,
      };
      this.fields.push(orgName);
      this.fields.push(dataCode);
      console.log(this.fields, this.activeFields, "this.activeFields");
      const queryExtFields = {};
      this.activeFields.forEach((item) => {
        if (item.key) {
          queryExtFields[item.key] = undefined;
        }
      });
      this.query = { ..._.pick(this.query, ["type"]), ...queryExtFields };

      this.queryList();
    },
    handleSetField(array) {
      array = array || [];
      array = array.filter((item) => item.isEffective === 1);
      const fields = [];
      for (let i = 0, len = array.length; i < len; i++) {
        const item = array[i];
        const col = {
          id: item.id,
          key: `ext${item.extNo}`,
          name: item.extName,
          type: "input",
        };
        if (item.isEnum === 1) {
          col.type = "enums";
          col.enums = jt.fn.generateEnums(item.enumValue, ",");
          col.render = (h, { row }) => {
            const enumValue = col.enums.find(
              (elem) => elem.value === row[col.key]
            );
            return <span>{enumValue ? enumValue.label : ""}</span>;
          };
        }
        fields.push(col);
      }
      return fields;
    },
    async querySearchThink(value, cb, key) {
      let { id } = this.query.type || {};
      if (!id) return;
      const query = {
        typeId: id,
        tenementCode: this.tenementCode,
        dataRoleId: this.entity.id,
        ..._.omit(this.query, ["type"]),
      };
      jt.object.removeEmptyAttr(query);
      const params = { data: query, page: { pageIndex: 1, pageSize: 10 } };
      const { data, msg, code } = await api.dataRole.queryDataResourceList(
        params
      );
      if (code === 200) {
        data.rows = data.rows || [];
        const array = Array.from(new Set(data.rows.map((item) => item[key])));
        const result = array.map((item) => ({ value: item }));
        cb(result);
      } else {
        cb();
      }
    },
  },
  computed: {
    closeText() {
      if (this.action === "add") {
        return `${this.$t('language.5o6u3frcn8k0')}`;
      } else {
        return `${this.$t('language.5o6uut7rgac0')}`;
      }
    },
    okText() {
      if (this.action === "edit") {
        return `${this.$t('language.5o6u3frcn9k0')}`;
      } else if (this.action === "add") {
        return `${this.$t('language.5o6vkto5xjo0')}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-form {
  display: flex;
  .col-l {
    flex: 1;
    display: flex;
    .el-row {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      margin-right: 20px;
    }
    .el-autocomplete {
      width: 100%;
    }
  }
  .col-r {
    width: 140px;
  }
}
.basic-list {
  padding-top: 0;
}
</style>
